import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { HeaderHelperService } from '../header-helper.service';

export interface AdminReportFilterModel {
  customerCode?: string;
  year?: number | null;
  month?: number | null;
  doctor?: string;
}
@Injectable({
  providedIn: 'root',
})
export class ReportService {
  constructor(
    private http: HttpClient,
    private headerHelperService: HeaderHelperService
  ) {}

  analysisReportList(
    page: number,
    size: number,
    filters?: AdminReportFilterModel
  ): Observable<any> {
    let url = `${
      environment.apiLocations.patient
    }/AdminReport/GetAnalysisReportCount?PageRequest.PageIndex=${
      page - 1
    }&PageRequest.PageSize=${size}`;

    if (filters?.customerCode) {
      url += `&CustomerCode=${filters.customerCode}`;
    }

    if (filters?.month) {
      url += `&Month=${filters.month}`;
    }

    if (filters?.year) {
      url += `&Year=${filters.year}`;
    }

    return this.http.get<any>(url, {
      headers: this.headerHelperService.getHeaders(),
    });
  }

  patientReportList(
    page: number,
    size: number,
    filters?: AdminReportFilterModel
  ): Observable<any> {
    let url = `${
      environment.apiLocations.patient
    }/AdminReport/GetPatientCount?PageRequest.PageIndex=${
      page - 1
    }&PageRequest.PageSize=${size}`;

    if (filters?.customerCode) {
      url += `&CustomerCode=${filters.customerCode}`;
    }

    if (filters?.month) {
      url += `&Month=${filters.month}`;
    }

    if (filters?.year) {
      url += `&Year=${filters.year}`;
    }

    return this.http.get<any>(url, {
      headers: this.headerHelperService.getHeaders(),
    });
  }

  doctorReportList(
    page: number,
    size: number,
    filters: any = {}
  ): Observable<any> {
    let url = `${
      environment.apiLocations.patient
    }/AdminReport/GetAnalysisReportCountByDoctor?PageRequest.PageIndex=${
      page - 1
    }&PageRequest.PageSize=${size}`;

    if (filters.doctor) {
      url += `&DoctorId=${filters.doctor}`;
    }

    if (filters.month) {
      url += `&Month=${filters.month}`;
    }

    if (filters.year) {
      url += `&Year=${filters.year}`;
    }

    return this.http.get<any>(url, {
      headers: this.headerHelperService.getHeaders(),
    });
  }
}
